import moment from "moment";

export function printEstimatedDate(value, days, usMode = false) {
  const date = moment(value);
  const diff = moment.duration(days, "d");
  const diffAsWeeks = Math.round(diff.asWeeks());
  const diffType = diffAsWeeks > 1 ? `${diffAsWeeks} weeks` : `${diff.days()} days`;
  return usMode
    ? `${date.format("dd")} ${date.format("MM-DD-YYYY")} (${diffType})`
    : `${date.format("dd.")} ${date.format("DD.MM.")} (${diffType})`;
}
